// extracted by mini-css-extract-plugin
export default {"applist":"AppList_applist__b-OG5"};